import React from "react";
import SlotCard from "./SlotCard";

const StackGroup = ({ groupName, slots, selectedSlotIds = [], onSlotClick, onHeaderClick }) => {
    return (
        <div className="flex flex-col p-2.5 rounded-2xl border-2 border-dashed border-gray-200 dark:border-bordercolor bg-white dark:bg-dashboardbg w-[94px] items-center">
            <div 
                className="text-center mb-2.5 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 p-1 rounded-md transition-colors w-full"
                onClick={onHeaderClick}
            >
                <span className="text-[10px] font-bold text-gray-700 dark:text-textprimary uppercase tracking-wider">
                    {groupName}
                </span>
            </div>
            
            <div className="flex flex-col gap-2">
                {slots.map((slot) => (
                    <SlotCard
                        key={slot.id}
                        slot={slot}
                        isStacked={true}
                        isSelected={selectedSlotIds.includes(slot.id)}
                        onClick={onSlotClick}
                    />
                ))}
            </div>
        </div>
    );
};

export default StackGroup;
